import { render, staticRenderFns } from "./sliders.vue?vue&type=template&id=2283bb4b&scoped=true&"
import script from "./sliders.vue?vue&type=script&lang=js&"
export * from "./sliders.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./sliders.vue?vue&type=style&index=1&id=2283bb4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2283bb4b",
  null
  
)

export default component.exports